import { createTheme } from "@mui/material/styles";
import { tenant } from "../config/tenant";

const { colors } = tenant;

export const muiTheme = createTheme({
  palette: {
    primary: {
      main: colors.muiPrimaryMain,
      light: colors.muiPrimaryLight,
      dark: colors.muiPrimaryDark,
    },
    ...(colors.muiSecondary
      ? {
          secondary: {
            main: colors.muiSecondary.main,
            light: colors.muiSecondary.light,
            dark: colors.muiSecondary.dark,
          },
        }
      : {}),
    error: {
      main: "#ff3b3b",
    },
    text: {
      secondary: "#6B7588",
    },
  },
});
